<aside class="cr-sidebar" [class.collapsed]="collapsed">
  <button
    type="button"
    class="cr-sidebar-edge-expand"
    *ngIf="collapsed"
    (click)="toggleCollapsed.emit()"
    title="Show blocks"
  >
    <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
      <path d="M3 4h14M3 10h14M3 16h14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
    </svg>
  </button>

  <ng-container *ngIf="!collapsed">
    <div class="cr-sidebar-head">
      <div class="cr-sidebar-search">
        <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
          <circle cx="9" cy="9" r="6" stroke="currentColor" stroke-width="1.6"/>
          <path d="M17 17l-3.5-3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
        </svg>
        <input class="cr-sidebar-search-input" type="text" placeholder="Search blocks" [(ngModel)]="search" />
      </div>
      <button type="button" class="cr-icon-btn" (click)="toggleCollapsed.emit()" title="Collapse">
        <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
          <path d="M13 4l-6 6 6 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>

    <div
      class="cr-block-list"
      cdkDropList
      [cdkDropListDisabled]="dragDisabled"
      (cdkDropListDropped)="reorder.emit($event)"
    >
      <div
        *ngFor="let block of filteredBlocks; let i = index; trackBy: trackByBlockId"
        class="cr-block-row"
        cdkDrag
        [cdkDragDisabled]="dragDisabled || isLocked(block)"
        [class.active]="block.blockId === selectedBlockId"
        [class.locked]="isLocked(block)"
        role="button"
        tabindex="0"
        (click)="selectBlock.emit(block.blockId)"
        (keydown.enter)="selectBlock.emit(block.blockId)"
        (keydown.space)="selectBlock.emit(block.blockId)"
      >
        <div class="cr-block-row-placeholder" *cdkDragPlaceholder></div>

        <span class="cr-drag-handle" cdkDragHandle [class.disabled]="isLocked(block)">
          <svg width="12" height="16" viewBox="0 0 12 16" fill="currentColor">
            <circle cx="3" cy="2" r="1.3"/><circle cx="9" cy="2" r="1.3"/>
            <circle cx="3" cy="8" r="1.3"/><circle cx="9" cy="8" r="1.3"/>
            <circle cx="3" cy="14" r="1.3"/><circle cx="9" cy="14" r="1.3"/>
          </svg>
        </span>
        <span class="cr-status-dot"></span>
        <span class="cr-block-index">{{ i + 1 }}</span>
        <span class="cr-block-name">{{ displayName(block) }}</span>

        <div class="cr-block-row-actions" *ngIf="!isLocked(block)">
          <button
            type="button"
            class="cr-icon-btn cr-block-action"
            (click)="duplicateBlock.emit(block.blockId); $event.stopPropagation()"
            title="Duplicate block"
          >
            <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
              <rect x="3" y="3" width="10" height="10" rx="1.4" stroke="currentColor" stroke-width="1.5" />
              <path d="M7 17h9a1 1 0 0 0 1-1V7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
          <button
            type="button"
            class="cr-icon-btn cr-block-action cr-block-action-delete"
            (click)="deleteBlock.emit(block.blockId); $event.stopPropagation()"
            title="Delete block"
          >
            <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
              <path d="M4 6h12M8 6V4h4v2M6 6l1 10h6l1-10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>

      <div class="cr-sidebar-add-section" *ngIf="showAddBlock">
        <button
          type="button"
          class="cr-btn cr-btn-secondary cr-sidebar-add-block-btn"
          [disabled]="addBlockDisabled"
          [title]="addBlockDisabled ? 'Lock the template to add blocks' : ''"
          (click)="onAddBlockAtEndClick()"
        >
          + Add new block
        </button>
      </div>
    </div>
  </ng-container>
</aside>
